import { render, staticRenderFns } from "./AssumptionsImpactsNaturalGasEmissionsFactor.vue?vue&type=template&id=ef3b69a8&"
import script from "./AssumptionsImpactsNaturalGasEmissionsFactor.vue?vue&type=script&lang=js&"
export * from "./AssumptionsImpactsNaturalGasEmissionsFactor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports